const BusinessInABox = () => {
  // Data for the 6 cards
  const features = [
    {
      icon: "./icons/stars.svg",
      title: "Brand Identity & Design",
      description:
        "From logo creation and packaging design to a high-conversion website, we craft a unique identity that stands out in the market.",
    },
    {
      icon: "./icons/balance.svg",
      title: "Legal & Compliance",
      description:
        "Skip the red tape. We assist with necessary business licenses, registrations, and legal documentation to ensure compliance.",
    },
    {
      icon: "./icons/search.svg",
      title: "Verified Vendor Network",
      description:
        "Access our vetted network of manufacturers. Whether it's complex textiles or custom hard goods, we produce at factory-direct prices.",
    },
    {
      icon: "./icons/bookmark.svg",
      title: "Packaging & Logistics",
      description:
        "We handle premium custom packaging (unboxing experience) and manage the entire shipping lifecycle directly to your customers.",
    },
    {
      icon: "./icons/circuit.svg",
      title: "Tech & Ops",
      description:
        "We set up the digital backbone of your business, ensuring you have the right software to manage orders, inventory, and payments.",
    },
    {
      icon: "./icons/flash.svg",
      title: "Marketing Launchpad",
      description:
        "Don't just launch; explode onto the scene. We provide social media assets and marketing strategies to help secure your first customers.",
    },
  ];

  return (
    <section className="w-full bg-[#F4EFED] py-24 px-6 md:px-12">
      <div className="max-w-[1440px] mx-auto">
        {/* 
            Header Section
     */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-normal text-gray-900 mb-4 tracking-tight">
            Your <span className="text-[#737373]">Business</span> in a Box
          </h2>
          <p className="text-gray-500 text-sm md:text-base font-medium">
            Complete End-to-End Support for new entrepreneurs.
          </p>
        </div>

        {/* 
            Features Grid
          */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 md:p-10 flex flex-col items-start hover:shadow-lg transition-shadow duration-300 h-full"
            >
              {/* Icon Wrapper */}
              <img className="mb-6 lg:w-10 lg:h-10 w-8 h-8" src={feature.icon}></img>

              {/* Content */}
              <h3 className="text-2xl font-normal text-gray-900 mb-4">
                {feature.title}
              </h3>

              <p className="text-[#737373] text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessInABox;
